// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuelidate from "vuelidate";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import store from "./store";
import "datalist-polyfill";
import { money, serviceName, carrierName, dash } from "./utils/format";
import PageHeader from "./components/ui/PageHeader";
import StatCard from "./components/ui/StatCard";
import TablePagination from "./components/ui/TablePagination";
import EmptyState from "./components/ui/EmptyState";
import TrackingStatus from "./components/ui/TrackingStatus";

Vue.config.productionTip = false;

Vue.filter("money", money);
Vue.filter("serviceName", serviceName);
Vue.filter("carrierName", carrierName);
Vue.filter("dash", dash);

// Componentes de interfaz compartidos por todas las vistas del panel
Vue.component("PageHeader", PageHeader);
Vue.component("StatCard", StatCard);
Vue.component("TablePagination", TablePagination);
Vue.component("EmptyState", EmptyState);
Vue.component("TrackingStatus", TrackingStatus);

Vue.use(Vuelidate);
Vue.use(BootstrapVue, {
  // Delay global para todos los v-b-tooltip: 2s antes de mostrarse, sin
  // retraso al ocultarse. Evita que aparezcan de inmediato en cada botón/campo.
  BTooltip: { delay: { show: 2000, hide: 0 } },
});

Vue.directive("help", {
  bind(el, binding) {
    el.setAttribute("title", binding.value);
    el.setAttribute("data-toggle", "tooltip");
    el.setAttribute("data-placement", "top");
    el._v_tooltip_content = binding.value;
  },
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js